<!-- Header wrapper -->
<div class="cc-content-header-panel d-flex justify-content-between align-items-center">

  <!--Title-->
  <h3>{{'_General_LWA_Text_' | translate }}</h3>
  <button *ngIf="userPermissionList?.includes(54)" id="addLeftWithoutAssistantReasonButton" class="btn btn-primary"
    (click)="addHandler(grid)" [disabled]="data && data.total > 9">{{'_LWA_Add_Reason_Button_Text_' | translate }}
    </button>
</div>

<div class="cc-content-wrapper">

  <!-- LWAReason Grid Wrapper -->
  <div>
    <!-- Grid  -->
    <kendo-grid #grid [data]="data" [pageable]="false" (edit)="editHandler($event)"
      (save)="saveHandler($event)" (cancel)="cancelHandler($event)" (remove)="removeHandler($event)" scrollable="scrollable">
      <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>
     
      <kendo-grid-column field="language" title="{{'_General_Language_Text_' | translate }}" [width]="120" [headerStyle]="{'font-weight' : 'bold'}">
        <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-dataItem="dataItem" let-column="column">
          <select
            class="cc-select-dropdown form-control"
            [(ngModel)]="dataItem.language"
            [formControl]="formGroup.get(column.field)"
            (change)="onLanguageChange(dataItem)">
            <option *ngFor="let lang of languages; trackBy: languageTrackBy" [ngValue]="lang">{{lang.languageName | translate}}</option>
          </select>
        </ng-template>
        
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <div class="checklist-item">
             <div class="checklist-item-name">{{dataItem.language.languageName | translate }}</div>
          </div>
        </ng-template>
      </kendo-grid-column>

      <!--kendo-grid-column field="language" title="{{'_General_Language_Text_' | translate }}" [width]="150" [headerStyle]="{'font-weight' : 'bold'}">
        <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-dataItem="dataItem" let-column="column">
          <select
            class="cc-select-dropdown form-control"
            [(ngModel)]="dataItem.language"
            [formControl]="formGroup.get(column.field)"
            (change)="onLanguageChange(dataItem)">
            <option *ngFor="let lang of languages; trackBy: languageTrackBy" [ngValue]="lang">{{lang.languageName | translate}}</option>
          </select>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <div class="checklist-item">
            <span
              [ngClass]="draggable && !editingItem ? 'k-icon k-i-pan checklist-item-drag-enabled' : 'k-icon k-i-pan checklist-item-drag-disabled'"
              title="{{'_Checklist_Item_Display_Order_Message_Text_' | translate }}"></span>
            <div class="checklist-item-name ">{{dataItem.language.languageName | translate }}</div>
          </div>
        </ng-template>
      </kendo-grid-column-->

      <kendo-grid-column field="reason" title="{{'_General_Reason_Text_' | translate }}"
        [headerStyle]="{'font-weight' : 'bold'}">
        <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-dataItem="dataItem" let-column="column">
          <input #reason (change)="onReasonTextChanged()" (keypress)="keypress($event)" (paste)="textPasteEvent($event)"
            [(ngModel)]="dataItem.reason" kendoGridFocusable name="reason" class="form-control" maxlength=150
            [formControl]="formGroup.get(column.field)"  />
          <!-- <kendo-popup [anchor]="reason"
            *ngIf="formGroup.get(column.field).invalid && !(formGroup.get(column.field).untouched)"
            popupClass="k-widget k-tooltip k-tooltip-validation k-invalid-msg">
            Enter a value in the 'Reason for Left Without Assistance’ field before saving
          </kendo-popup> -->
          <div>
            <div *ngIf="formGroup.get(column.field).invalid && !(formGroup.get(column.field).untouched)"
              class="cc-validation opt-hours-validation">
              {{'_LWA_Reason_Required_Validation_Message_Text_' | translate }}
            </div>
            <div *ngIf="isLWAAlreadyExists"
              class="cc-validation opt-hours-validation">
              {{'_LWA_LWA_Already_Exist_Validation_Message_Text_' | translate }}
            </div>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column class="d-flex" title="{{'_General_Button_Action_Text_' | translate }}" [width]="150" [headerStyle]="{'font-weight' : 'bold', 'text-align':'center', 'justify-content': 'center'}"
        *ngIf="(userPermissionList?.includes(54) || userPermissionList?.includes(55) || userPermissionList?.includes(56))">
        <ng-template kendoGridCellTemplate let-dataItem let-isNew="isNew">
          <div class="cell-items-center">
          <button *ngIf="userPermissionList?.includes(55)" kendoGridEditCommand type="button"
            [iconClass]="'fas fa-pen cc-icon-btn'" title="{{'_General_Button_Edit_Text_' | translate }}"></button>
          <button *ngIf="userPermissionList?.includes(56)" kendoGridRemoveCommand type="button"
            [iconClass]="'fas fa-trash-alt cc-icon-btn'" title="{{'_General_Button_Delete_Text_' | translate }}"></button>
          <button kendoGridSaveCommand type="button" [iconClass]="'fas fa-save cc-icon-btn'" title="{{'_General_Button_Save_Text_' | translate }}"
            [disabled]="saveButtonDisabled(formGroup)"></button>
          <button kendoGridCancelCommand type="button" [iconClass]="'fas fa-times cc-icon-btn'" title="{{'_General_Button_Cancel_Text_' | translate }}"></button>
        </div>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>

<app-modalpopup header="{{'_LWA_Delete_Popup_Header_Text_' | translate }}" [(dialogOpened)]="openeDeleteconfirmationDialog"
  [isInfo]="false" actionNoLabel="{{'_General_Action_Label_No_Text_' | translate }}" actionYesLabel="{{'_General_Action_Label_Yes_Text_' | translate }}"
  message="{{'_LWA_Delete_Popup_Confirmation_Message_Text_' | translate }}"
  (submitted)="closeDeleteDialog('yes')" (cancelled)="closeDeleteDialog('no')">
</app-modalpopup>
